module.exports = __webpack_public_path__ + "img/Weapon_198.20a79b91.png";